var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7175 2.07461C17.7175 0.927632 16.7876 0 15.6429 0C14.4982 0 13.5683 0.929917 13.5683 2.07461C13.5683 3.21929 14.4982 4.14921 15.6429 4.14921C16.7876 4.14921 17.7175 3.21929 17.7175 2.07461ZM17.7701 9.6099L17.4296 6.06159C17.3679 5.41956 16.8013 4.94661 16.1547 5.01058C15.5127 5.07227 15.042 5.64348 15.1037 6.28551L15.4921 10.3273L15.6452 11.929C15.6452 11.9358 15.6452 11.9427 15.6452 11.9495L16.4723 20.5541C16.5317 21.1596 17.0389 21.612 17.6353 21.612C17.6718 21.612 17.7107 21.612 17.7495 21.6074C18.3915 21.5457 18.8622 20.9745 18.8005 20.3325L17.7701 9.61219V9.6099ZM17.6535 20.7895C17.4342 20.7895 17.256 20.6112 17.256 20.3919C17.256 20.1726 17.4342 19.9944 17.6535 19.9944C17.8729 19.9944 18.0511 20.1726 18.0511 20.3919C18.0511 20.6112 17.8729 20.7895 17.6535 20.7895Z",
    fill: "url(#paint0_linear_1_1600)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2658 30.3148C25.0443 30.3148 25.6755 29.6836 25.6755 28.9051C25.6755 28.1265 25.0443 27.4953 24.2658 27.4953C23.4872 27.4953 22.856 28.1265 22.856 28.9051C22.856 29.6836 23.4872 30.3148 24.2658 30.3148Z",
    fill: "url(#paint1_linear_1_1600)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8216 30.3148C32.6002 30.3148 33.2314 29.6836 33.2314 28.9051C33.2314 28.1265 32.6002 27.4953 31.8216 27.4953C31.0431 27.4953 30.4119 28.1265 30.4119 28.9051C30.4119 29.6836 31.0431 30.3148 31.8216 30.3148Z",
    fill: "url(#paint2_linear_1_1600)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77556 15.098C6.86924 15.0683 6.9515 15.0134 7.01319 14.9403L7.81515 13.8048C8.05049 13.5877 8.27668 13.4666 8.59427 13.5078C8.95299 13.5557 9.26372 13.7819 9.41909 14.1087L12.0215 18.8953L12.5653 18.2693C12.7229 18.1116 12.8303 17.9083 12.8714 17.6867L14.3291 9.99144C14.5302 8.93129 14.432 7.85514 14.0732 6.86354L14.1349 5.18649C14.0732 4.7638 13.8699 4.37309 13.5592 4.07835L12.8349 3.39291C12.6932 3.26039 12.4762 3.25126 12.3254 3.37464L11.7542 4.34796L10.9636 3.92527C10.726 3.79732 10.429 3.90014 10.3193 4.1469L6.26148 13.8619C6.05813 14.2709 6.3346 15.2328 6.76871 15.0957L6.77556 15.098ZM16.518 29.2021L9.51276 15.0843C9.29342 14.6433 8.84789 14.3828 8.37265 14.4285C7.89969 14.4719 7.50214 14.8101 7.36048 15.2853L5.25388 22.3979L0.241016 29.2547C-0.151971 29.7916 -0.0537248 30.5616 0.458072 30.9728C0.670559 31.1442 0.919603 31.2264 1.16865 31.2264C1.52051 31.2264 1.8678 31.0619 2.09628 30.7466L7.28508 23.65C7.33763 23.5792 7.37647 23.5015 7.39932 23.417L8.74964 18.8565L14.4434 30.3331C14.7404 30.934 15.4487 31.167 16.0199 30.854C16.5934 30.541 16.815 29.803 16.518 29.2021Z",
    fill: "url(#paint3_linear_1_1600)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9529 13.0097C17.4959 12.6716 16.3924 11.8696 15.9537 11.536C15.6841 11.3281 15.4328 11.0928 15.2043 10.8391L15.1312 10.0737C14.8593 9.86582 14.6079 9.63962 14.384 9.38372C14.2812 9.26263 14.183 9.13696 14.0916 9.00673C14.0345 8.85593 13.9796 8.70285 13.9271 8.54977L12.2112 4.52165C11.4778 2.98169 9.25007 4.0327 9.96521 5.57495L11.9667 9.47055C12.5105 10.7455 13.8951 12.3517 15.4053 13.1125C15.6521 13.2519 16.9339 13.9853 17.2149 14.1453C17.5096 14.3143 17.8935 14.2389 18.0991 13.9579C18.3208 13.6563 18.2568 13.2313 17.9552 13.0074L17.9529 13.0097Z",
    fill: "url(#paint4_linear_1_1600)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.69 17.2046C23.2216 17.2046 22.8857 17.6501 23.0137 18.1002L23.1965 18.7514C23.2833 19.0553 23.5597 19.2632 23.8751 19.2632H25.4127L24.8073 17.2046H23.69Z",
    fill: "url(#paint5_linear_1_1600)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.21 9.60303C32.5916 9.60303 29.2215 9.60303 29.2215 9.60303H18.1037L19.1318 20.3005C19.2118 21.1253 18.604 21.861 17.7792 21.941C17.7312 21.9456 17.681 21.9478 17.633 21.9478C17.3428 21.9478 17.0732 21.8656 16.8424 21.7239C17.2514 22.3545 17.9551 22.7727 18.7548 22.7727H19.061V23.1976C19.061 25.0986 20.6055 26.6431 22.5065 26.6431H33.7112C34.2641 26.6431 34.7119 26.1953 34.7119 25.6424C34.7119 25.0895 34.2641 24.6416 33.7112 24.6416H22.5065C21.7114 24.6416 21.0648 23.995 21.0648 23.1999V22.7749H32.2717C33.5901 22.7749 34.7485 21.8999 35.1072 20.6295L37.4034 12.5139C37.817 11.0562 36.7225 9.60531 35.2054 9.60531L35.21 9.60303ZM27.3183 21.0636H23.2536C21.8073 21.0636 20.8317 20.1017 20.4433 18.7103L20.0252 15.395C19.454 13.3433 20.7061 11.3121 22.8355 11.3121H25.2345C25.4447 11.3121 25.6275 11.4514 25.6869 11.6525L25.9314 12.5139C26.0159 12.8132 25.7897 13.1102 25.479 13.1102H23.0114C22.5453 13.1102 22.2072 13.5557 22.3351 14.0058L22.5202 14.657C22.6047 14.9609 22.8835 15.1688 23.1965 15.1688H25.8674C26.0913 15.1688 26.2901 15.3173 26.3495 15.5344L26.642 16.5694L27.4965 19.5922L27.6633 20.1817L27.7501 20.4924C27.8324 20.7803 27.6153 21.0636 27.3183 21.0636ZM36.0028 11.8901L35.7926 12.635C35.7127 12.916 35.4568 13.1102 35.1666 13.1102H31.3807C31.0654 13.1102 30.7889 13.3204 30.7021 13.622L30.5193 14.2732C30.3914 14.7233 30.7295 15.1688 31.1979 15.1688H34.2116C34.6457 15.1688 34.961 15.5847 34.8422 16.0028L33.6723 20.136C33.517 20.6843 33.0166 21.0636 32.4454 21.0636H31.1111C30.0235 21.0636 29.057 20.5221 28.4721 19.6859C28.3487 19.5077 28.4858 19.2632 28.7006 19.2632H31.3121C31.6274 19.2632 31.9039 19.053 31.9907 18.7514L32.1735 18.1002C32.3014 17.6501 31.9633 17.2046 31.4949 17.2046H28.5407C28.1385 17.2046 27.8027 16.8961 27.7707 16.494L27.6313 14.7895C27.4782 12.916 28.9588 11.3098 30.8392 11.3098H35.5664C35.868 11.3098 36.0874 11.5999 36.0051 11.8901H36.0028Z",
    fill: "url(#paint6_linear_1_1600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1600",
    x1: 20.5347,
    y1: 20.6318,
    x2: 13.2873,
    y2: 0.724286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1600",
    x1: 23.5621,
    y1: 30.1251,
    x2: 24.9718,
    y2: 27.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1600",
    x1: 31.1156,
    y1: 30.1251,
    x2: 32.5254,
    y2: 27.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1600",
    x1: 8.32467,
    y1: 3.2901,
    x2: 8.32467,
    y2: 31.2242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_1600",
    x1: 14.0276,
    y1: 14.2367,
    x2: 14.0276,
    y2: 3.76766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_1600",
    x1: 17.2377,
    y1: 22.4025,
    x2: 37.248,
    y2: 10.8482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_1600",
    x1: 17.5873,
    y1: 23.0057,
    x2: 37.5976,
    y2: 11.4514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2689a1e96ddbbb38b30ad9d3ce47a105.svg";
export { ForwardRef as ReactComponent };